const content = {
  'content-images-breadcrumbs': 'Images',
  'content-image-colors-amount': 'Colors amount',
  'content-image-taps': 'Taps amount',
  'content-images-folder-name-placeholder': 'Specify Bee Id(s)',
  'content-images-status-placeholder': 'Specify status(es)',
  'content-images-taps-from-label': 'Taps from',
  'content-images-taps-to-label': 'Taps to',
  'content-images-colors-from-label': 'Colors from',
  'content-images-colors-to-label': 'Colors to',
  'content-images-imported-from-label': 'Imported from',
  'content-images-imported-to-label': 'Imported to',
  'content-images-released-from-label': 'Released from',
  'content-images-released-to-label': 'Released to',
  'content-images-category-label': 'Category',
  'content-images-category-client-id': 'Client ID',
  'content-images-category-deleted-at': 'Deleted at',
  'content-images-tags-label': 'Tags',
  'content-images-only-main-category-label': 'Only main category',
  'content-images-main-category-label': 'Main category',
  'content-images-labels-label': 'Labels',
  'content-images-image-type-label': 'Image type',
  'content-images-layout-label': 'Layout',
  'content-images-hashtags-label': 'Hashtags',
  'content-images-exclude-hashtags-label': 'Exclude hashtags',
  'content-images-recommended-types-label': 'Recommended types',
  'content-images-recommended-types-placeholder': 'Specify recommended type(s)',
  'content-images-exclude-recommended-types-label': 'Exclude recommended types',
  'content-images-format-label': 'Format',
  'content-images-taps-difficulty-label': 'Taps difficulty',
  'content-images-taps-difficulty-label-placeholder': 'Specify difficulty level',
  'content-images-layout-label-placeholder': 'Specify layout(s)',
  'content-images-hashtags-label-placeholder': 'Specify hashtag(s)',
  'content-images-tags-label-placeholder': 'Specify tag(s)',
  'content-images-format-label-placeholder': 'Specify format(s)',
  'content-images-tag-placeholder': 'Specify tag(s)',
  'content-image-preview-card-title': 'Image preview',
  'content-image-preview-taps-label': 'Taps / Colors',
  'content-images-clone-confirm-message': 'Are you sure you want to clone image?',
  'content-images-reopen-confirm-message': 'Are you sure you want to reopen image?',
  'content-image-reopen-success': 'Image reopened successfully',
  'content-image-reopen-failed': 'Image reopen failed',
  'content-image-filter-loading': 'Filter loading...',
  'content-images-show-contour': 'Show lines',
  'content-images-show-colors': 'Show colors',
  'content-images-main-category': 'Main category',
  'content-images-main-category-placeholder': 'Choose main category',
};

export default content;
